import {
  ADD_COMMUNICATION,
  ADD_COMMUNICATION_FAILED,
  ADD_COMMUNICATION_SUCCESS,
  DELETE_COMMUNICATION,
  DELETE_COMMUNICATION_FAILED,
  DELETE_COMMUNICATION_SUCCESS,
  GET_COMMUNICATION,
  GET_COMMUNICATION_FAILED,
  GET_COMMUNICATION_SUCCESS,
  GET_CUSTOM_EMAILS,
  GET_CUSTOM_EMAILS_FAILED,
  GET_CUSTOM_EMAILS_SUCCESS,
  GET_EVENTS_BY_SEARCH,
  GET_EVENTS_BY_SEARCH_FAILED,
  GET_EVENTS_BY_SEARCH_SUCCESS,
  GET_USERS,
  GET_USERS_FAILED,
  GET_USERS_SUCCESS,
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_FAILED,
  GET_NOTIFICATIONS_SUCCESS,
  GET_WEB_ALERTS,
  GET_WEB_ALERTS_FAILED,
  GET_WEB_ALERTS_SUCCESS,
  HIDE_DELETE_COMMUNICATION_MODAL,
  HIDE_SEND_COMMUNICATION_MODAL,
  HIDE_SEND_WEB_ALERT_MODAL,
  OPEN_DELETE_COMMUNICATION_MODAL,
  OPEN_SEND_COMMUNICATION_MODAL,
  OPEN_SEND_WEB_ALERT_MODAL,
  RESET_COMMUNICATION,
  SEND_COMMUNICATION,
  SEND_COMMUNICATION_FAILED,
  SEND_COMMUNICATION_SUCCESS,
  SEND_WEB_ALERT,
  SEND_WEB_ALERT_FAILED,
  SEND_WEB_ALERT_SUCCESS,
  UPDATE_COMMUNICATION,
  UPDATE_COMMUNICATION_FAILED,
  UPDATE_COMMUNICATION_SUCCESS,
  RESET_USERS_LIST,
} from "./actionTypes"

export const getNotifications = params => ({
  type: GET_NOTIFICATIONS,
  payload: params,
})

export const getNotificationsSuccess = response => ({
  type: GET_NOTIFICATIONS_SUCCESS,
  payload: response,
})

export const getNotificationsFailed = error => ({
  type: GET_NOTIFICATIONS_FAILED,
  payload: error,
})

export const getCustomEmails = params => ({
  type: GET_CUSTOM_EMAILS,
  payload: params,
})

export const getCustomEmailsSuccess = response => ({
  type: GET_CUSTOM_EMAILS_SUCCESS,
  payload: response,
})

export const getCustomEmailsFailed = error => ({
  type: GET_CUSTOM_EMAILS_FAILED,
  payload: error,
})

export const getWebAlerts = params => ({
  type: GET_WEB_ALERTS,
  payload: params,
})

export const getWebAlertsSuccess = response => ({
  type: GET_WEB_ALERTS_SUCCESS,
  payload: response,
})

export const getWebAlertsFailed = error => ({
  type: GET_WEB_ALERTS_FAILED,
  payload: error,
})

export const getEventsBySearch = params => ({
  type: GET_EVENTS_BY_SEARCH,
  payload: params,
})

export const getEventsBySearchSuccess = response => ({
  type: GET_EVENTS_BY_SEARCH_SUCCESS,
  payload: response,
})

export const getEventsBySearchFailed = error => ({
  type: GET_EVENTS_BY_SEARCH_FAILED,
  payload: error,
})

export const addCommunication = (values, history) => ({
  type: ADD_COMMUNICATION,
  payload: { values, history },
})

export const addCommunicationSuccess = response => ({
  type: ADD_COMMUNICATION_SUCCESS,
  payload: response,
})

export const addCommunicationFailed = error => ({
  type: ADD_COMMUNICATION_FAILED,
  payload: error,
})

export const openDeleteCommunicationModal = () => ({
  type: OPEN_DELETE_COMMUNICATION_MODAL,
  payload: {},
})

export const hideDeleteCommunicationModal = () => ({
  type: HIDE_DELETE_COMMUNICATION_MODAL,
  payload: {},
})

export const deleteCommunication = params => ({
  type: DELETE_COMMUNICATION,
  payload: params,
})

export const deleteCommunicationSuccess = response => ({
  type: DELETE_COMMUNICATION_SUCCESS,
  payload: response,
})

export const deleteCommunicationFailed = error => ({
  type: DELETE_COMMUNICATION_FAILED,
  payload: error,
})

export const getCommunication = params => ({
  type: GET_COMMUNICATION,
  payload: params,
})

export const getCommunicationSuccess = response => ({
  type: GET_COMMUNICATION_SUCCESS,
  payload: response,
})

export const getCommunicationFailed = error => ({
  type: GET_COMMUNICATION_FAILED,
  payload: error,
})

export const resetCommunication = () => ({
  type: RESET_COMMUNICATION,
  payload: {},
})

export const updateCommunication = (values, history) => ({
  type: UPDATE_COMMUNICATION,
  payload: { values, history },
})

export const updateCommunicationSuccess = response => ({
  type: UPDATE_COMMUNICATION_SUCCESS,
  payload: response,
})

export const updateCommunicationFailed = error => ({
  type: UPDATE_COMMUNICATION_FAILED,
  payload: error,
})

export const openSendCommunicationModal = () => ({
  type: OPEN_SEND_COMMUNICATION_MODAL,
  payload: {},
})

export const hideSendCommunicationModal = () => ({
  type: HIDE_SEND_COMMUNICATION_MODAL,
  payload: {},
})

export const sendCommunication = params => ({
  type: SEND_COMMUNICATION,
  payload: params,
})

export const sendCommunicationSuccess = response => ({
  type: SEND_COMMUNICATION_SUCCESS,
  payload: response,
})

export const sendCommunicationFailed = error => ({
  type: SEND_COMMUNICATION_FAILED,
  payload: error,
})

export const openSendWebAlertModal = () => ({
  type: OPEN_SEND_WEB_ALERT_MODAL,
  payload: {},
})

export const hideSendWebAlertModal = () => ({
  type: HIDE_SEND_WEB_ALERT_MODAL,
  payload: {},
})

export const sendWebAlert = params => ({
  type: SEND_WEB_ALERT,
  payload: params,
})

export const sendWebAlertSuccess = response => ({
  type: SEND_WEB_ALERT_SUCCESS,
  payload: response,
})

export const sendWebAlertFailed = error => ({
  type: SEND_WEB_ALERT_FAILED,
  payload: error,
})

export const getUsers = params => ({
  type: GET_USERS,
  payload: params,
})

export const getUsersSuccess = response => ({
  type: GET_USERS_SUCCESS,
  payload: response,
})

export const getUsersFailed = error => ({
  type: GET_USERS_FAILED,
  payload: error,
})

export const resetUsersList = () => ({
  type: RESET_USERS_LIST,
  payload: {},
})
